import inView from 'in-view';

class Tabs {
  constructor(tabs) {
    this.tabs = tabs;

    this.selectors = {
      navLink: '.js-tabs-nav-link',
      navLinkScroll: '.js-tabs-nav-link-scroll',
      tabPane: '.js-tabs-content-item',
    };

    this.classes = {
      active: 'is-active',
    };

    this.init();
    this.initScroll();
  }

  initScroll() {
    const links = Array.from(
      document.querySelectorAll(this.selectors.navLinkScroll),
    );

    inView.offset(400);
    inView('.js-tabs-content-item').on('enter', (el) => {
      const link = document.querySelector(
        `${this.selectors.navLinkScroll}[href="#${el.id}"]`,
      );
      if (link) {
        links.forEach((l) => {
          l.classList.remove(this.classes.active);
        });
        link.classList.add(this.classes.active);
      }
    });
  }

  init() {
    const activeLinkOnInit = this.tabs.querySelector(
      `${this.selectors.navLink}.${this.classes.active}`,
    );

    if (activeLinkOnInit) {
      setTimeout(() => {
        document.dispatchEvent(
          new CustomEvent('tabs:init', {
            detail: { activeTab: activeLinkOnInit.getAttribute('href') },
          }),
        );
      }, 100);
    }

    this.tabs.querySelectorAll(this.selectors.navLink).forEach((navLink) => {
      navLink.addEventListener('click', (e) => {
        e.preventDefault();

        const link = e.currentTarget;

        if (link.classList.contains(this.classes.active)) {
          return;
        }

        const target = link.getAttribute('href');
        const pane = this.tabs.querySelector(
          `${this.selectors.tabPane}${target}`,
        );

        const activeLink = this.tabs.querySelector(
          `${this.selectors.navLink}.${this.classes.active}`,
        );
        const activePane = this.tabs.querySelector(
          `${this.selectors.tabPane}.${this.classes.active}`,
        );

        activeLink.classList.remove(this.classes.active);
        activePane.classList.remove(this.classes.active);
        link.classList.add(this.classes.active);
        pane.classList.add(this.classes.active);

        document.dispatchEvent(
          new CustomEvent('tab:changed', {
            detail: { activeTab: target },
          }),
        );
      });
    });
  }
}

export default () => {
  const sections = document.querySelectorAll('.js-tabs');

  if (sections.length) {
    sections.forEach((tabs) => new Tabs(tabs));
  }
};
